export const HandleUserOrganisationSettingsChange = (field, value, setUser) => {
    setUser((previous) => ({
        ...previous,
        organisation_settings: {
            ...previous.organisation_settings,
            [field]: field == 'taxe_rate' ? value?.replace(',', '.') : value,
        },
    }))
}
